import React from 'react'
import '@ant-design/compatible/assets/index.css';
import { Button, message } from "antd";
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import _ from 'lodash';
import { FileExcelOutlined } from '@ant-design/icons';

export const ExportCSVSftp = ({csvData, fileName, columnNames}) => {

    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';
  
  
    const exportToCSV = (csvData, fileName, columnNames) => {
        let expectedResults = [];
        let expectedTempObj = {};
            if(csvData != null){
                try{
                    expectedResults = csvData.map((j) =>{
                        let filtered_temp = Object.keys(j).reduce((acc,curr) =>{
                         
                         
                            let colObj = {};
                            const tempObj = columnNames.some((col)=>{ 
                                colObj = col;
                                return col.dataIndex == curr
                            })
                         
                            if(tempObj){
                                let temp = _.pick(j,curr);
                                const _key = colObj.title;
                                const _value =  Array.isArray(temp[curr])?JSON.stringify(temp[curr]):temp[curr]
                                acc.push({[_key]:_value});
                        
                            }
                           return acc;
                         
                        },[]);
                        expectedTempObj =  Object.assign({},...filtered_temp);
                 
                        return expectedTempObj;
                    });
              
                    const ws = XLSX.utils.json_to_sheet(expectedResults);
                    const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
                    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
                    const data = new Blob([excelBuffer], {type: fileType});
                    FileSaver.saveAs(data, fileName + fileExtension); 
            }catch (err){
                message.error(err)
            } 
        }
        else{
            message.error('There are no valid data to export');
        }
     
    }

    return (
        <Button icon={<FileExcelOutlined />} type="primary" style={{marginBottom:'15px'}} onClick={(e) => exportToCSV(csvData,fileName,columnNames)}>Export</Button>
    )
}

export default ExportCSVSftp;